import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';

export const ClubNameChanged = createAction('[Clubs: Create New]: Club Name Changed', props<{ clubName: string }>());

export const ClubCodeChanged = createAction('[Clubs: Create New]: Club Code Changed', props<{ clubCode: string }>());

export const ClubStartDateChanged = createAction(
  '[Clubs: Create New]: Club Start Date Changed',
  props<{ clubStartDate: Date; clubStartDateFormat: string }>(),
);

export const ClubStartDateCleared = createAction('[Clubs: Create New]: Club Start Date Cleared');

export const ClubEndDateChanged = createAction(
  '[Clubs: Create New]: Club End Date Changed',
  props<{ clubEndDate: Date; clubEndDateFormat: string }>(),
);

export const ClubEndDateCleared = createAction('[Clubs: Create New]: Club End Date Cleared');

export const ClubDiscountTypeChanged = createAction(
  '[Clubs: Create New]: Club Discount Type Changed',
  props<{ clubDiscountType: string }>(),
);

export const ClubDiscountAmountChanged = createAction(
  '[Clubs: Create New]: Club Discount Amount Changed',
  props<{ clubDiscountAmount: string }>(),
);

export const ClubDiscountPercentageChanged = createAction(
  '[Clubs: Create New]: Club Discount Percentage Changed',
  props<{ clubDiscountPercentage: string }>(),
);

export const DeactivateClubChanged = createAction('[Clubs: Create New]: Deactivate Club Changed');

export const SyncClubMemberChanged = createAction('[Clubs: Create New]: Sync ClubMember Changed');

export const CreateClub = createAction('[Clubs: Create New]: Create Club');

export const CreateClubSuccess = createAction('[Clubs: Create New]: Create Club Success', props<{ res: QcResponse }>());

export const CreateClubFailed = createAction(
  '[Clubs: Create New]: Create Club Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateClub = createAction('[Clubs: Create New]: Update Club');

export const UpdateClubSuccess = createAction('[Clubs: Create New]: Update Club Success', props<{ res: QcResponse }>());

export const UpdateClubFailed = createAction(
  '[Clubs: Create New]: Update Club Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ResetClub = createAction('[Clubs: Create New]: Reset Club');
